import { render, staticRenderFns } from "./CheckAdminHistory.vue?vue&type=template&id=4b42d020&scoped=true"
import script from "./CheckAdminHistory.vue?vue&type=script&lang=js"
export * from "./CheckAdminHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b42d020",
  null
  
)

export default component.exports